<template>
  <div class="study-lecture-template" theme>
    <div id="study-lecture-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'study',
      parts: [
        {
          elem: '#study-lecture-content',
          htmlFile: 'study-lecture'
        }
      ]
    }
  }
}
</script>
